import React from 'react';
import { Download, Mail, CreditCard, FileText } from 'lucide-react';
export function RegistrationSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-923">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-924">
        <div className="text-center mb-12 md:mb-16 mb-12" data-id="element-925">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-white uppercase tracking-wider mb-4" data-id="element-926">
            Interested in Hosting a Program?
          </h2>
          <div className="w-16 h-0.5 bg-brand-teal mx-auto" data-id="element-927" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-928">
          <div className="p-8 border border-brand-gray-800 bg-brand-gray-900 flex flex-col items-center" data-id="element-929">
            <Mail className="w-8 h-8 text-brand-teal mb-4" data-id="element-930" />
            <h3 className="text-lg font-bold text-brand-white uppercase mb-2" data-id="element-931">
              Contact Training Coordinator
            </h3>
            <a href="mailto:Training@apc360zone.com" className="text-brand-gray-300 hover:text-brand-teal transition-colors" data-id="element-932">
              Training@apc360zone.com
            </a>
          </div>

          <div className="p-8 border border-brand-gray-800 bg-brand-gray-900 flex flex-col items-center" data-id="element-933">
            <FileText className="w-8 h-8 text-brand-teal mb-4" data-id="element-934" />
            <h3 className="text-lg font-bold text-brand-white uppercase mb-2" data-id="element-935">
              Submit Registration
            </h3>
            <p className="text-brand-gray-300 mb-1" data-id="element-936">Fax: 1-(866) 635-5761</p>
            <a href="mailto:Training@apc360zone.com" className="text-brand-gray-300 hover:text-brand-teal transition-colors" data-id="element-937">
              Email: Training@apc360zone.com
            </a>
          </div>
        </div>

        <div className="space-y-6 max-w-2xl mx-auto" data-id="element-938">
          <div className="p-6 border-2 border-brand-gray-800 bg-brand-gray-900/50" data-id="element-939">
            <h3 className="text-xl font-bold text-brand-white uppercase tracking-wide mb-2" data-id="element-940">
              Accepted Payment Methods
            </h3>
            <p className="text-brand-gray-400" data-id="element-941">
              Agency / Company Checks, Purchase Orders, and Money Orders
            </p>
          </div>

          <div className="p-6 border-2 border-brand-teal/30 bg-brand-teal/5 flex flex-col items-center" data-id="element-942">
            <CreditCard className="w-8 h-8 text-brand-teal mb-3" data-id="element-943" />
            <h3 className="text-xl font-bold text-brand-white uppercase tracking-wide mb-2" data-id="element-944">
              Secure Credit Card Payments
            </h3>
            <p className="text-brand-gray-300" data-id="element-945">
              For credit card payment, either call by phone or mail in with
              registration information.
            </p>
          </div>
        </div>

        <div className="mt-16" data-id="element-946">
          <a href="https://www.apc360zone.com/uploaded/files/COURSE+REGISTRATION+FORM+2024.pdf?direct=1" target="_blank" rel="noreferrer" className="inline-flex items-center text-brand-teal font-bold uppercase tracking-wider hover:text-brand-teal-light transition-colors" data-id="element-947">
            <Download className="w-5 h-5 mr-2" data-id="element-948" />
            Download Course Registration Form Here
          </a>
        </div>
      </div>
    </section>;
}